/* eslint-disable max-classes-per-file */
/* eslint-disable @typescript-eslint/no-extraneous-class */

import { Residence } from '@app/shared/models/dictionaries/residence';

export class GetCitizenship {
  static readonly type = 'Get citizenship';
}

export class GetPurpose {
  static readonly type = 'Get citizenship';
}

export class GetResidence {
  static readonly type = 'Get Residence';
}
